export const EMP_INFO_SYSTEM_NAME = 'PAISY Wert' as const;
